// @generated by protobuf-ts 2.11.0 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/v1/http_request.proto" (package "bianka.common.v1", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../../google/protobuf/wrappers";
import { FloatValue } from "../../../google/protobuf/wrappers";
/**
 * Next serial number to be used: 26
 *
 * @generated from protobuf message bianka.common.v1.HttpRequest
 */
export interface HttpRequest {
    /**
     * Request's user agent
     *
     * @generated from protobuf field: string user_agent = 1
     */
    userAgent: string;
    /**
     * The ip the request came from
     *
     * @generated from protobuf field: string ip = 2
     */
    ip: string;
    /**
     * Request's method
     *
     * @generated from protobuf field: string method = 3
     */
    method: string;
    /**
     * Request's url
     *
     * @generated from protobuf field: string url = 4
     */
    url: string;
    /**
     * Request's referrer's url
     *
     * @generated from protobuf field: string referrer = 5
     */
    referrer: string;
    /**
     * Request's mobile app version
     *
     * @generated from protobuf field: string mobile_app_version = 6
     */
    mobileAppVersion: string;
    /**
     * Indicates if the request came from a bot
     *
     * @generated from protobuf field: bool is_bot = 7
     */
    isBot: boolean;
    /**
     * Indicates if the request is an ajax request
     *
     * @generated from protobuf field: bool is_xhr = 8
     */
    isXhr: boolean;
    /**
     * The city the request came from
     *
     * @generated from protobuf field: string city = 9
     */
    city: string;
    /**
     * The country the request came from
     *
     * @generated from protobuf field: string country = 10
     */
    country: string;
    /**
     * The country code the request came from
     *
     * @generated from protobuf field: string country_code = 11
     */
    countryCode: string;
    /**
     * The subdivision the request came from
     *
     * @generated from protobuf field: string subdivision = 12
     */
    subdivision: string;
    /**
     * The subdivision code the request came from
     *
     * @generated from protobuf field: string subdivision_code = 13
     */
    subdivisionCode: string;
    /**
     * The continent the request came from
     *
     * @generated from protobuf field: string continent = 14
     */
    continent: string;
    /**
     * The time zode the request came from
     *
     * @generated from protobuf field: string time_zone = 15
     */
    timeZone: string;
    /**
     * The latitude the request came from
     *
     * @generated from protobuf field: google.protobuf.FloatValue latitude = 16
     */
    latitude?: FloatValue;
    /**
     * The longitude the request came from
     *
     * @generated from protobuf field: google.protobuf.FloatValue longitude = 17
     */
    longitude?: FloatValue;
    /**
     * Request's browser language
     *
     * @generated from protobuf field: string browser_language = 18
     */
    browserLanguage: string;
    /**
     * Request's os
     *
     * @generated from protobuf field: string os = 19
     */
    os: string;
    /**
     * Request's os version
     *
     * @generated from protobuf field: string os_version = 20
     */
    osVersion: string;
    /**
     * Request's device
     *
     * @generated from protobuf field: string device = 21
     */
    device: string;
    /**
     * Request's browser
     *
     * @generated from protobuf field: string browser = 22
     */
    browser: string;
    /**
     * Request's browser version
     *
     * @generated from protobuf field: string browser_version = 23
     */
    browserVersion: string;
    /**
     * Response's time
     *
     * @generated from protobuf field: google.protobuf.FloatValue response_time = 24
     */
    responseTime?: FloatValue;
    /**
     * Response's status
     *
     * @generated from protobuf field: google.protobuf.StringValue status = 25
     */
    status?: StringValue;
}
// @generated message type with reflection information, may provide speed optimized methods
class HttpRequest$Type extends MessageType<HttpRequest> {
    constructor() {
        super("bianka.common.v1.HttpRequest", [
            { no: 1, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "referrer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mobile_app_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_bot", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "is_xhr", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "subdivision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "subdivision_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "continent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "latitude", kind: "message", T: () => FloatValue },
            { no: 17, name: "longitude", kind: "message", T: () => FloatValue },
            { no: 18, name: "browser_language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "os", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "os_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "device", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "browser", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "browser_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "response_time", kind: "message", T: () => FloatValue },
            { no: 25, name: "status", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<HttpRequest>): HttpRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAgent = "";
        message.ip = "";
        message.method = "";
        message.url = "";
        message.referrer = "";
        message.mobileAppVersion = "";
        message.isBot = false;
        message.isXhr = false;
        message.city = "";
        message.country = "";
        message.countryCode = "";
        message.subdivision = "";
        message.subdivisionCode = "";
        message.continent = "";
        message.timeZone = "";
        message.browserLanguage = "";
        message.os = "";
        message.osVersion = "";
        message.device = "";
        message.browser = "";
        message.browserVersion = "";
        if (value !== undefined)
            reflectionMergePartial<HttpRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HttpRequest): HttpRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_agent */ 1:
                    message.userAgent = reader.string();
                    break;
                case /* string ip */ 2:
                    message.ip = reader.string();
                    break;
                case /* string method */ 3:
                    message.method = reader.string();
                    break;
                case /* string url */ 4:
                    message.url = reader.string();
                    break;
                case /* string referrer */ 5:
                    message.referrer = reader.string();
                    break;
                case /* string mobile_app_version */ 6:
                    message.mobileAppVersion = reader.string();
                    break;
                case /* bool is_bot */ 7:
                    message.isBot = reader.bool();
                    break;
                case /* bool is_xhr */ 8:
                    message.isXhr = reader.bool();
                    break;
                case /* string city */ 9:
                    message.city = reader.string();
                    break;
                case /* string country */ 10:
                    message.country = reader.string();
                    break;
                case /* string country_code */ 11:
                    message.countryCode = reader.string();
                    break;
                case /* string subdivision */ 12:
                    message.subdivision = reader.string();
                    break;
                case /* string subdivision_code */ 13:
                    message.subdivisionCode = reader.string();
                    break;
                case /* string continent */ 14:
                    message.continent = reader.string();
                    break;
                case /* string time_zone */ 15:
                    message.timeZone = reader.string();
                    break;
                case /* google.protobuf.FloatValue latitude */ 16:
                    message.latitude = FloatValue.internalBinaryRead(reader, reader.uint32(), options, message.latitude);
                    break;
                case /* google.protobuf.FloatValue longitude */ 17:
                    message.longitude = FloatValue.internalBinaryRead(reader, reader.uint32(), options, message.longitude);
                    break;
                case /* string browser_language */ 18:
                    message.browserLanguage = reader.string();
                    break;
                case /* string os */ 19:
                    message.os = reader.string();
                    break;
                case /* string os_version */ 20:
                    message.osVersion = reader.string();
                    break;
                case /* string device */ 21:
                    message.device = reader.string();
                    break;
                case /* string browser */ 22:
                    message.browser = reader.string();
                    break;
                case /* string browser_version */ 23:
                    message.browserVersion = reader.string();
                    break;
                case /* google.protobuf.FloatValue response_time */ 24:
                    message.responseTime = FloatValue.internalBinaryRead(reader, reader.uint32(), options, message.responseTime);
                    break;
                case /* google.protobuf.StringValue status */ 25:
                    message.status = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HttpRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_agent = 1; */
        if (message.userAgent !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAgent);
        /* string ip = 2; */
        if (message.ip !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ip);
        /* string method = 3; */
        if (message.method !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.method);
        /* string url = 4; */
        if (message.url !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        /* string referrer = 5; */
        if (message.referrer !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.referrer);
        /* string mobile_app_version = 6; */
        if (message.mobileAppVersion !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mobileAppVersion);
        /* bool is_bot = 7; */
        if (message.isBot !== false)
            writer.tag(7, WireType.Varint).bool(message.isBot);
        /* bool is_xhr = 8; */
        if (message.isXhr !== false)
            writer.tag(8, WireType.Varint).bool(message.isXhr);
        /* string city = 9; */
        if (message.city !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.city);
        /* string country = 10; */
        if (message.country !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.country);
        /* string country_code = 11; */
        if (message.countryCode !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.countryCode);
        /* string subdivision = 12; */
        if (message.subdivision !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.subdivision);
        /* string subdivision_code = 13; */
        if (message.subdivisionCode !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.subdivisionCode);
        /* string continent = 14; */
        if (message.continent !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.continent);
        /* string time_zone = 15; */
        if (message.timeZone !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.timeZone);
        /* google.protobuf.FloatValue latitude = 16; */
        if (message.latitude)
            FloatValue.internalBinaryWrite(message.latitude, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FloatValue longitude = 17; */
        if (message.longitude)
            FloatValue.internalBinaryWrite(message.longitude, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string browser_language = 18; */
        if (message.browserLanguage !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.browserLanguage);
        /* string os = 19; */
        if (message.os !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.os);
        /* string os_version = 20; */
        if (message.osVersion !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.osVersion);
        /* string device = 21; */
        if (message.device !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.device);
        /* string browser = 22; */
        if (message.browser !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.browser);
        /* string browser_version = 23; */
        if (message.browserVersion !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.browserVersion);
        /* google.protobuf.FloatValue response_time = 24; */
        if (message.responseTime)
            FloatValue.internalBinaryWrite(message.responseTime, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue status = 25; */
        if (message.status)
            StringValue.internalBinaryWrite(message.status, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.v1.HttpRequest
 */
export const HttpRequest = new HttpRequest$Type();
